<script>
import Vue from 'vue';
import {mapState, mapGetters, mapActions} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            user: state => state.auth.user,
            contract: state => state.contract.contract.item
        }),
        ...mapGetters({
            calculateContractProgress: 'contract/calculateContractProgress'
        })
    },
    methods: {
        ...mapActions({
            acceptContract: 'contract/acceptContract'
        })
    }
});
</script>
<template>
    <div class="contract-form-accept">
        <transition name="fade" mode="out-in">
            <div v-if="!contract.supplierConfirm && calculateContractProgress === 100 && !user.contractManager"
                 class="contract-form-accept__content">
                <div class="contract-form-accept__left">
                    {{ $t('contract.form.accept') }}
                </div>
                <div class="contract-form-accept__right">
                    <button class="contract-form-accept__btn" @click="acceptContract">
                        {{ $t('contract.form.sendAccept') }}
                    </button>
                </div>
            </div>
            <div v-else-if="contract.supplierConfirm" class="contract-form-accept__content">
                <div class="contract-form-accept__left">
                    {{ $t('contract.form.accepted') }}
                </div>
                <div class="contract-form-accept__right">
                    {{ contract.supplierConfirm | moment('DD/MM/YYYY') }}
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormAccept/ContractFormAccept.vue